import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Button from "@mui/material/Button";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import { FaDownload } from "react-icons/fa";

const UnitDetailsReportGenerate = ({
  excelData,
  sheetName,
  fileName,
  className,
  exportPosition,
  transformData,
  color
}) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";
  var wscols = [
    { wch: 20 },
    { wch: 20 },
    { wch: 40 },
    { wch: 20 },
    { wch: 25 },
    { wch: 20 },
    { wch: 20 },
    { wch: 30 },
    { wch: 30 },
    { wch: 30 },
    { wch: 30 },
    { wch: 20 },
    { wch: 20 },

    
  ];
//   const addStyles = (workSheet) => {
//     Object.entries(workSheet)
//       .filter(([k, v]) => k.charAt(0) === "A")
//       .forEach(([k, v]) => {
//         if (v.v === "Year") {
//           v.s = {
//             fill: {
//               fgColor: { rgb: "FFFFFF" },
//             },
//             alignment: {
//               vertical: "center",
//               horizontal: "center",
//             },
//             font: {
//               bold: false,
//             },
//           };
//         } else {
//           v.s = {
//             alignment: {
//               vertical: "center",
//               horizontal: "center",
//               wrapText: true,
//             },
//             width: {
//               auto: true,
//             },
//             height: {
//               auto: true,
//             },
//             font: {
//               bold: true,
//             },
//           };
//         }
//       });

//     Object.entries(workSheet)
//       .filter(([k, v]) =>
//         ["B", "C", "D", "E", "F", "G", "H"].includes(k.charAt(0))
//       )
//       .forEach(([k, v]) => {
//         v.s = {
//           alignment: {
//             vertical: "center",
//             horizontal: "center",
//             wrapText: true,
//           },
//           width: {
//             auto: true,
//           },
//           height: {
//             auto: true,
//           },
//         };
//       });
//   };


const addStyles = (workSheet) => {
    Object.entries(workSheet)
      .filter(([k, v]) => k.match(/^[A-Z]1$/)) // Target all headers (first row)
      .forEach(([k, v]) => {
        v.s = {
          fill: {
            fgColor: { rgb: `${color}` }, // Red background
          },
          alignment: {
            vertical: "center",
            horizontal: "Left",
          },
          font: {
            bold: true,
            color: { rgb: "FFFFFF" }, // White text for contrast
          },
        };
      });
  
    Object.entries(workSheet)
      .filter(([k, v]) => k.match(/^[A-Z][2-9]\d*$/)) // Apply styles for other rows
      .forEach(([k, v]) => {
        v.s = {
          alignment: {
            vertical: "center",
            horizontal: "left",
            wrapText: true,
          },
        };
      });
  };
  
  const excelDataLength = excelData && excelData.length;
  const rowHeight = Array(excelDataLength)
    .fill()
    .map((item) => ({ hpt: 30 }));

  const exportTOExcel = async () => {
    
    console.log("excelData");
    console.log(excelData);

    const transformedData = transformData(excelData);
    const ws = XLSX.utils.json_to_sheet(transformedData);
   
    console.log("excelData");
    console.log(transformedData);

    const range = ws["!ref"];
    ws["!autofilter"] = { ref: range };
    addStyles(ws);
    ws["!cols"] = wscols;
    ws["!rows"] = rowHeight;
    const wb = {
      Sheets: { [`${sheetName}`]: ws },
      SheetNames: [`${sheetName}`],
    };
    console.log(wb);

    const exelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([exelBuffer], { type: fileType });
    console.log(exelBuffer);

    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px",
        border: "none",
        position: `${exportPosition ? "absolute" : "unset"}`,
        top: "0px",
        right: "12px",
        cursor: "pointer",
        backgroundColor: `#${color}`
      }}
      title="Export in Excel"
      onClick={(e) => exportTOExcel(fileName)}
      // className={`${className}`}

      className="bg-orange-400 p-3 rounded-md flex items-center gap-2 hover:bg-green-300 transition-colors duration-200 cursor-pointer text-gray-800 hover:text-gray-900"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M9.75 15.75H19.6275L17.6925 17.6925L18.75 18.75L22.5 15L18.75 11.25L17.6925 12.3075L19.6275 14.25H9.75V15.75Z"
          fill="#ffffff"
        />
        <path
          d="M16.5 10.5V7.50001C16.5006 7.40131 16.4817 7.30346 16.4443 7.21208C16.407 7.1207 16.352 7.03759 16.2825 6.96751L11.0325 1.71751C10.9624 1.648 10.8793 1.59301 10.7879 1.55568C10.6966 1.51836 10.5987 1.49944 10.5 1.50001H3C2.60218 1.50001 2.22064 1.65805 1.93934 1.93935C1.65804 2.22066 1.5 2.60219 1.5 3.00001V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H15C15.3978 22.5 15.7794 22.342 16.0607 22.0607C16.342 21.7794 16.5 21.3978 16.5 21V19.5H15V21H3V3.00001H9V7.50001C9 7.89784 9.15804 8.27937 9.43934 8.56067C9.72064 8.84198 10.1022 9.00001 10.5 9.00001H15V10.5H16.5ZM10.5 7.50001V3.30751L14.6925 7.50001H10.5Z"
          fill="#ffffff"
        />
      </svg>
      <p
        style={{
          marginBottom: "0",
          color: "#ffffff",
          fontSize: "18px",
          fontWeight: "500",
        }}
      >
        Export Table
      </p>
    </div>
  );
};

export default UnitDetailsReportGenerate;
